<template>
  <section class="dashboard-view">
    <div class="dashboard-inner-view">
      <div class="right-block">
        <TopbarTopDog
          v-if="
            getAuthenticatedUser && getAuthenticatedUser.user_type === 'TOP_DOG'
          "
        ></TopbarTopDog>

        <TopbarDefault
          v-else-if="getAuthenticatedUser"
          @onChangeStatus="onChangeStatus"
        ></TopbarDefault>
        <main class="main-dashboard-view">
          <router-view :layout="layout" />
        </main>
      </div>
    </div>
  </section>
</template>

<script>
import { defineAsyncComponent } from "vue";
const TopbarTopDog = defineAsyncComponent(() =>
  import("@/layouts/TopbarTopDog")
);
const TopbarDefault = defineAsyncComponent(() =>
  import("@/layouts/TopbarDefault")
);

import { mapGetters } from "vuex";
export default {
  name: "home",
  components: {
    TopbarDefault,
    TopbarTopDog,
  },
  data() {
    return {
      layout: "div",
      isOpen: "",
      routerValue: "",
      clientLogin: false,
    };
  },
  computed: {
    ...mapGetters("auth", ["getAuthenticatedUser", "getAuthenticationDetails"]),
  },
  mounted() {
    this.checkIsAdmin();
  },
  methods: {
    onChangeStatus(data) {
      this.selectedCaseStatus = data.status;
      this.selectedRouteName = data.name;
    },
    checkIsAdmin() {
      if (this.$route.path === "/") {
        if (
          this.getAuthenticatedUser &&
          this.getAuthenticatedUser.user_type &&
          this.getAuthenticatedUser.user_type === "TOP_DOG"
        ) {
          this.$router.push({ name: "AllLabs" });
        } else {
          this.$router.push({ path: "/signin" });
        }
      } else {
        this.clientLogin = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
